import { createTheme } from '@material-ui/core/styles';

const darkTheme = createTheme({
    palette: {
        type: 'dark',
    },
});

export default darkTheme;
